import { Icons } from "./icons";
import { cn } from "@/lib/cn";
import "./control-motion-recipes.css";

function normalizeCheckPath(svg: SVGSVGElement | null) {
  // Normalize the existing shared icon so stroke drawing is independent of its size.
  svg?.querySelector("path")?.setAttribute("pathLength", "1");
}

export function CheckboxCheck({
  checked,
  className,
}: {
  checked: boolean;
  className?: string;
}) {
  return (
    <Icons.Check
      ref={normalizeCheckPath}
      className={cn("denker-checkbox-check", className)}
      data-checked={String(checked)}
      aria-hidden="true"
    />
  );
}
